import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import CategoryPage from "@/pages/category/page";
import TagPage from "@/pages/tag/page";
import SearchPage from "@/pages/search/page";
import VideoDetailPage from "@/pages/video/page";
import AboutPage from "@/pages/about/page";
import ContactPage from "@/pages/contact/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "category/:categorySlug",
        element: <CategoryPage />,
      },
      {
        path: "tag/:tagSlug",
        element: <TagPage />,
      },
      {
        path: "search",
        element: <SearchPage />,
      },
      {
        path: "video/:videoId",
        element: <VideoDetailPage />,
      },
      {
        path: "about",
        element: <AboutPage />,
      },
      {
        path: "contact",
        element: <ContactPage />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;